import { makeStyles } from '@material-ui/core';
import { isDesktop, isLaptop, isTablet } from 'helpers/device_helper';
import palette from 'muiTheme/config/palette';

interface Props {
    loggedIn: boolean;
    theme: 'light' | 'dark';
    fixedDisclaimerRow: boolean;
    system_side_menu_state: boolean;
    disableMainBottomMargin?: boolean;
    isEconomicCalendarPage?: boolean;
}

export default makeStyles(() => ({
    app_container: (props) => ({
        display: 'flex',
        flexGrow: 1,
        ...(props.isEconomicCalendarPage && {
            height: '100dvh',
            minHeight: '-webkit-fill-available',
            '@supports not (height: 100dvh)': {
                height: '100vh',
            },
        }),
    }),
    header: {
        display: 'block',
        height: '7rem',
        position: 'relative',
    },
    body: (props: Props) => ({
        display: 'grid',
        flex: 1,
        gridTemplateRows: 'auto 1fr auto',
        ...(props.isEconomicCalendarPage && {
            overflow: 'hidden',
        }),
        position: 'relative',
        width: '100%',
        overflowY: 'hidden',
        overflowX: 'hidden',
        maxWidth: '100vw',
        filter: props.system_side_menu_state ? 'blur(8px)' : 'none',
        ...isLaptop({ filter: 'none' }),
    }),
    side_menu: (props: Props) => ({
        '@media print': {
            display: 'none',
        },
        backgroundColor: palette(props.theme).side_menu.background,
        ...isTablet({
            minWidth: '6.4rem',
        }),
        ...isDesktop({
            minWidth: 'auto',
        }),
    }),
    main: ({ loggedIn, disableMainBottomMargin, isEconomicCalendarPage }: Props) => ({
        marginBottom: loggedIn && !disableMainBottomMargin ? '75px' : 'unset',
        ...isTablet({
            height: isEconomicCalendarPage ? '100%' : 'auto',
        }),
        ...isDesktop({
            marginBottom: 'unset',
        }),
        ...(isEconomicCalendarPage && {
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100% - 75px)',
            marginBottom: 'unset',
        }),
    }),
    footer: {
        display: 'block',
        position: 'relative',
    },
    page_link: {
        '&:link,&:visited': {
            textDecoration: 'underline',
        },
    },
    bottomNavigationWrapper: {
        position: 'fixed',
        bottom: 0,
        zIndex: 1200,
        width: '100%',
    },
    keeper_container: {
        display: 'flex',
        placeContent: 'center',
        justifyContent: 'center',
    },
}));
